export default function IconoCircular({size, ruta}) {

  return (
    <div className={`contenedor-icono-perfil ${size}`}>
      <img id="img-icono-perfil" className="img-icono-perfil" src={`${ruta}`} alt=""/>
    </div>
  );
}
